import { compose } from 'recompose';
import Note from "./Note";
import enhancer from "./enhancer";
import { noteEnhancer } from "../../../pages/StudentApplication/enhancer";
import { userPermissionsEnhancer } from '@applyboard/ab-common';
export default compose(userPermissionsEnhancer, noteEnhancer, enhancer)(Note); // eslint-disable-line @typescript-eslint/no-explicit-any